function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgPlaca = function SvgPlaca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M4 6h24a2 2 0 012 2v17a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2zm0 1a1 1 0 00-1 1v17a1 1 0 001 1h24a1 1 0 001-1V8a1 1 0 00-1-1H4zm6.148 13.5l-.568-1.32H6.836l-.568 1.32h-1.04l2.552-5.64h.84l2.552 5.64h-1.024zm-2.976-2.12h2.064l-1.032-2.4-1.032 2.4zm7.46 1.288h1.224v.832h-3.48v-.832H13.6v-3.632l-.968.584-.408-.752 1.672-1.008h.736v4.808zm6.308 0v.832h-3.792v-.76l1.92-2.064c.224-.245.388-.47.492-.676.104-.205.156-.41.156-.612 0-.256-.073-.45-.22-.58-.147-.13-.361-.196-.644-.196-.507 0-1.016.195-1.528.584l-.344-.752c.224-.197.51-.356.86-.476s.7-.18 1.052-.18c.565 0 1.013.139 1.344.416.33.277.496.65.496 1.12 0 .325-.07.63-.208.916-.139.285-.373.604-.704.956l-1.384 1.472h2.504zm4.004-2.064c.33.085.585.247.764.484.179.237.268.532.268.884 0 .49-.18.879-.54 1.164-.36.285-.85.428-1.468.428-.379 0-.743-.059-1.092-.176a2.49 2.49 0 01-.868-.48l.344-.752c.49.39 1.016.584 1.576.584.357 0 .624-.07.8-.212.176-.141.264-.356.264-.644 0-.283-.09-.492-.268-.628-.179-.136-.455-.204-.828-.204h-.744v-.816h.608c.73 0 1.096-.275 1.096-.824 0-.256-.079-.453-.236-.592-.157-.139-.38-.208-.668-.208-.25 0-.505.05-.764.148-.259.099-.51.244-.756.436l-.344-.752c.224-.203.51-.363.86-.48.35-.117.705-.176 1.068-.176.555 0 .997.135 1.328.404.33.27.496.633.496 1.092a1.472 1.472 0 01-.244.82 1.306 1.306 0 01-.652.5zM10.462 11a.5.5 0 110-1H21.6a.5.5 0 010 1H10.462zm-4.385 0a.5.5 0 110-1H8a.5.5 0 110 1H6.077zm18 0a.5.5 0 110-1H26a.5.5 0 110 1h-1.923z"
  }));
};
SvgPlaca.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgPlaca.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgPlaca;